import React,{useState,useEffect} from 'react'
import './AdminDash.css'
import logo from './Images/logoFinal.png'
import {auth, db } from './Firebase';
import { Link ,useHistory} from 'react-router-dom'
import moment from 'moment'
import { useStateValue } from './StateProvider'
function AdminDash() {
    const [{ user },dispatch]= useStateValue();
    const [universites,setUnviersites]= useState([])
    const [uniname,setUniName]= useState([])
    const [pending,setPending]=useState([])
    const history = useHistory()
    useEffect(()=>{
            db.collection("Universities").where("RequestStatus","==","Approved").onSnapshot((query)=>{
                const u = []
                query.forEach((doc)=>{
                    u.push(doc.data())
                })
                setUnviersites(u)
            })
            db.collection("Universities").where("RequestStatus","==","pending").onSnapshot((query)=>{
                const u = []
                query.forEach((doc)=>{
                    u.push(doc.data())
                })
                setPending(u)
            })

           
    },[])
    const rejectUni=(name)=>{
        db.collection("Universities").doc(name.Name).delete()
    }
    const acceptuni=(name)=>{
        const up={
            RequestStatus:"Approved",
        }
        db.collection("Universities").doc(name.Name).update(up).catch((err)=>{
            console.log(err)
        })
    }
    const addUni=(e)=>{
        e.preventDefault()
        
            db.collection("Universities").doc(uniname).set({
                Name: uniname,
            }).then(()=>{
                alert("University Added")
            }).catch((error)=>{
                alert(error.message)
            })
            // db.collection("Reviews").doc("Christ University,Bangalore").collection("review").doc("R1").set({
            //     Namme:"Mo",
            //     Review:"Test Review",


            // }).then(()=>{
            //     console.log("Review Check")
            // }).catch((error)=>{
            //     alert(error.message)
            // })


        
    }
    const handleSignout=()=>{
        if(user){
            auth.signOut();
           
  
            history.push('/')
  
        }
    }
  return (
    <div className='admindash_main'>
        <div className="admin_header">
            <div className="admin_logo">
         <Link to='/'>  <img src={logo} alt="" /></Link>    
            </div>
            <div className="admin_title">
                <input type="search" placeholder='Search'/>
            </div>
            <div className="admin_logout">
                <button onClick={handleSignout}>Logout</button>
            </div>
        </div>
        <div className="admin_wrapper">
        <div className="admin_adduni">
            <h3>Univeristy Requests</h3>
            {
                pending.length == 0 ? <p>No New Requests 😢</p> :  <div className="admin_unireq">
                {
                    pending.map((pu)=>(
<div className="unireq_card" id={pu.Name} key={pu.Name}>
                    <div className="uni_title">
                        <p>{pu.Name}</p>
                    </div>
                    <div className="unicard_info">
                        <p>Requested By : {pu.RequestedBy}</p>
                        <p>  </p>
                    </div>
                    <div className="unireq_buttons">
                        <div className="unireq_accept">
                            <button onClick={()=>rejectUni(pu)} >Reject</button>

                        </div>
                        <div className="unireq_reject">
                            <button onClick={()=>acceptuni(pu)}>Accept</button>
                        </div>

            
                    </div>
                </div>
                    ))
                }
                
             
           
            </div>
            }
           
            {/* <div className="addUni">
                <p>University Name</p>
                <input type="text" value={uniname} onChange={e=>setUniName(e.target.value)}/>
                <div className="addUni_button">
                    <button onClick={addUni}>Add University</button>
                </div>
            </div> */}
        </div>
        <div className="admin_content">
            <div className="dash_card">
                <div className="cardname">
                    <p>Universtities Listed</p>

                </div>
                <div className="cardsummary">
                    {
                        
                            <p>{universites.length}</p>
                        
                    }
                </div>
            </div>
            <div className="dash_card">
                <div className="cardname">
                    <p>Total Users</p>

                </div>
                <div className="cardsummary">
                    <p>133</p>
                </div>
            </div>
            <div className="dash_card">
                <div className="cardname">
                    <p>Total Reviews</p>

                </div>
                <div className="cardsummary">
                    <p>67</p>
                </div>
            </div>
        </div>
        </div>
        
        
    </div>
  )
}

export default AdminDash